import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function HourglassBottomIcon(props: IconProps) {
    return <Icon {...props} iconKey={"hourglass_bottom"}/>
}
